export type ApiMode = 'real' | 'demo';

const parsePositiveNumber = (value: string | undefined, fallback: number): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const apiMode: ApiMode = import.meta.env.VITE_API_MODE === 'demo' ? 'demo' : 'real';
const configuredApiBaseUrl = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

// The Vite dev server proxies /api to the local backend. Keeping requests on the
// same origin avoids CORS failures when the UI is opened via 127.0.0.1, localhost,
// or the machine's LAN address. Production continues to use its configured API URL.
const useDevelopmentProxy = import.meta.env.DEV && window.location.port === '5173';

export const env = Object.freeze({
  apiMode,
  isDemo: apiMode === 'demo',
  apiBaseUrl: useDevelopmentProxy ? '' : configuredApiBaseUrl,
  appName: import.meta.env.VITE_APP_NAME || 'CRM عمومی',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  requestTimeoutMs: parsePositiveNumber(import.meta.env.VITE_REQUEST_TIMEOUT_MS, 20_000),
  defaultAssignmentTeamId: import.meta.env.VITE_DEFAULT_ASSIGNMENT_TEAM_ID || '',
});
